import { Box } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

import { COLORS } from 'styles/colors'
import { ReactComponent as ProfileIcon } from '../../../../../../assets/profile_icon.svg'

interface AvatarUploaderProps {
	initialAvatar?: string
	onChange?: (file: File | null) => void
}

const AvatarUploader: React.FC<AvatarUploaderProps> = ({
	initialAvatar,
	onChange,
}) => {
	const [avatarFile, setAvatarFile] = useState<File | null>(null)
	const [avatarPreview, setAvatarPreview] = useState<string | null>(
		initialAvatar || null,
	)
	const fileInputRef = useRef<HTMLInputElement>(null)

	useEffect(() => {
		setAvatarFile(null)
		setAvatarPreview(initialAvatar || null)
	}, [initialAvatar])

	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0]
		if (file) {
			setAvatarFile(file)
			setAvatarPreview(URL.createObjectURL(file))
			onChange?.(file)
		}
		e.target.value = ''
	}

	const handleRemove = () => {
		setAvatarFile(null)
		setAvatarPreview(null)
		onChange?.(null)
	}

	const openFileDialog = () => {
		fileInputRef.current?.click()
	}

	return (
		<Box display='flex' flexDirection='row' alignItems='center' gap={2}>
			<Box onClick={openFileDialog} sx={{ cursor: 'pointer' }}>
				{avatarPreview ? (
					<Avatar src={avatarPreview} sx={{ width: 128, height: 128 }} />
				) : (
					<ProfileIcon width={128} height={128} />
				)}
			</Box>
			<OutlinedButton
				sx={{
					width: 127,
					height: 33,
					color: !avatarPreview ? COLORS.main : COLORS.error,
					borderColor: !avatarPreview ? COLORS.main : COLORS.error,
					'&:hover': {
						color: COLORS.background,
						backgroundColor: !avatarPreview ? COLORS.main : COLORS.error,
						borderColor: !avatarPreview ? COLORS.main : COLORS.error,
					},
				}}
				onClick={() => {
					if (!avatarPreview) {
						openFileDialog()
					} else {
						handleRemove()
					}
				}}
			>
				<TypographySecondary
					sx={{
						color: 'inherit',
					}}
				>
					{!avatarPreview ? 'Загрузить фото' : 'Удалить фото'}
				</TypographySecondary>
			</OutlinedButton>
			<input
				ref={fileInputRef}
				type='file'
				hidden
				accept='image/*'
				onChange={handleFileChange}
			/>
		</Box>
	)
}

export default AvatarUploader
